import { cn } from "@/utils/classes";
import { cva, VariantProps } from "class-variance-authority";
import { UseFormRegisterReturn } from "react-hook-form";

/* Prop Types */
interface ToggleProps extends React.HTMLAttributes<HTMLInputElement>, VariantProps<typeof variants> {
  defaultChecked?: boolean;
  checked?: boolean;
  className?: string;
  registration?: UseFormRegisterReturn;
}

/* Variants */
const variants = cva("toggle", {
  variants: {
    variant: {
      success: "toggle-success",
      error: "toggle-error",
      warning: "toggle-warning",
      primary: "toggle-primary",
      secondary: "toggle-secondary",
      accent: "toggle-accent",
    },
    size: {
      small: "toggle-sm",
      medium: "toggle-md",
      large: "toggle-lg",
    },
  },
});

/*
 * Toggle component
 * This component works with react-hook-form and zod but can be used without it with state
 */
export const Toggle = ({ checked, defaultChecked, className, variant, size, registration, ...props }: ToggleProps) => {
  return <input type="checkbox" className={cn(variants({ variant, size }), className)} defaultChecked={defaultChecked} checked={checked} {...registration} {...props} />;
};
